module.exports = __webpack_public_path__ + "img/fourday_ps_07.9d6206a3.jpg";